import {
	createFilter,
	createBlacklistFilter,
} from 'redux-persist-transform-filter';

// createFilter and using transforms in redux persist to save nested sub-properties of application state
const saveRefundsFilters = createFilter('refunds', ['filters']);
// blacklisting pagination data for refunds
const saveRefundsFiltersBlackList = createBlacklistFilter('refunds', [
	'filters.offset',
	'filters.size',
]);

// blacklisting payment instruments for merchants
const saveFilteredUserConfig = createBlacklistFilter('userConfig', [
	'merchantPaymentInstruments',
]);

const saveTransactionFilters = createFilter('transactions', [
	'filters',
	'from',
	'to',
	'selectedDateType',
	'optionalFields',
]);

const saveDashboardFilters = createFilter('dashboard', [
	'filters',
	'to',
	'from',
	'selectedDateType',
]);

const saveSettlementFilters = createFilter('settlement', ['filters']);

const saveManageQRFilters = createFilter('manageQR', ['filters']);
// blacklisting pagination data for refunds
const saveManageQRFiltersBlackList = createBlacklistFilter('manageQR', [
	'filters.start',
	'filters.limit',
]);

const saveStoreListFilters = createFilter('store', [
	'pageNo',
	'pageSize',
	'merchantId',
]);

const saveUserProfileInfo = createFilter('userProfile', ['userRolesList.data']);

export {
	saveRefundsFilters,
	saveTransactionFilters,
	saveDashboardFilters,
	saveSettlementFilters,
	saveManageQRFilters,
	saveRefundsFiltersBlackList,
	saveFilteredUserConfig,
	saveStoreListFilters,
	saveManageQRFiltersBlackList,
	saveUserProfileInfo,
};
